import React from "react";
const TextInputTwoRow = ({
  placeholder = "",
  labelClass = "label-control",
  inputClass = "form-control input-sm",
  wrapperClass = "form-group",
  inputWrapClass = "col-md-8",
  labelText = "",
  starRed = "",
  inputProps = {},
  error,
}) => {
  return (
    <div>
      <label  className="label-control color7-bold">
        {labelText}{" "}
        <span
          className="canh-bao-red"
          style={{ margin: "-5px 0 0 0", display: "inline-block" }}
        >
          {starRed}
        </span>
      </label>
      <div>
        <input
          type="text"
          className={inputClass}
          placeholder={placeholder}
          {...inputProps}
        />
        {error && <span className="canh-bao-red">{error.message}</span>}
      </div>
    </div>
  );
};
export default TextInputTwoRow;
